<template>
  <div>
    <md-card class="px-md-4 mb-5">
      <md-card-content>

        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100 md-size-70 border pt-2">
            <h1 class="text-center">SIGNOS Y SINTOMAS</h1>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <h3 class="text-center">Primera vez en el año </h3>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <h3 class="text-center">Segunda vez en el año </h3>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma1.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma1.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma1.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma1.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma1.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma2.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma2.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma2.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma2.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma2.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma3.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma3.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma3.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma3.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma3.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma4.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma4.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma4.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma4.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma4.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma5.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma5.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma5.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma5.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma5.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo border">
          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma6.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma6.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma6.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma6.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma6.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">

            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma7.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma7.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma7.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma7.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma7.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma8.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma8.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma8.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma8.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma8.segundavez"
                :value="false"
              >No</md-radio>
            </div>

          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma9.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma9.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma9.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma9.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma9.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma10.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma10.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma10.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma10.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma10.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma11.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma11.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma11.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma11.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma11.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <!-- SIGNOS Y SINTOMAS NEUROLOGICOS FOCALES AGUDOS Y/O PROGRESIVOS -->

        <div class="md-layout md-gutter border">
          <div class="md-layout-item md-size-100">
            <h3>SIGNOS Y SÍNTOMAS NEUROLÓGICOS FOCALES AGUDOS Y/O PROGRESIVOS</h3>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma12.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma12.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma12.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma12.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma12.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma13.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma13.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma13.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma13.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma13.segundavez"
                :value="false"
              >No</md-radio>
            </div>

          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma14.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma14.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma14.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma14.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma14.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma15.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma15.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma15.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma15.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma15.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-rojo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma16.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma16.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma16.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 pl-4 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma16.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma16.segundavez"
                :value="false"
              >No</md-radio>
            </div>

          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma17.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma17.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma17.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma17.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma17.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma18.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma18.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma18.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma18.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma18.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma19.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma19.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma19.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma19.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma19.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-rojo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma20.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma20.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma20.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma20.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma20.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma21.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma21.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma21.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma21.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma21.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-rojo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma22.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma22.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma22.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma22.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma22.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <!-- SIGNOS O SINTOMAS DE OBSERVACION -->

        <div class="md-layout md-gutter border">
          <div class="md-layout-item md-size-100">
            <h3>SIGNOS O SÍNTOMAS DE OBSERVACIÓN</h3>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-amarillo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma23.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma23.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma23.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma23.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma23.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma24.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma24.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma24.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma24.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma24.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma25.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma25.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma25.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma25.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma25.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-amarillo border">

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma26.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma26.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma26.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma26.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma26.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

          <div class="md-layout-item md-size-100 md-layout md-gutter px-0">
            <div class="md-layout-item md-small-size-100 md-size-70">
              <p>{{sintomas.sintoma27.descripcion}}</p>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma27.primeravez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma27.primeravez"
                :value="false"
              >No</md-radio>
            </div>
            <div class="md-layout-item md-small-size-50 md-size-15 border-left border-right">
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma27.segundavez"
                :value="true"
              >Si</md-radio>
              <md-radio
                class="radio-color"
                v-model="sintomas.sintoma27.segundavez"
                :value="false"
              >No</md-radio>
            </div>
          </div>

        </div>

        <div class="md-layout md-gutter fondo-amarillo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma28.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma28.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma28.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma28.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma28.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-amarillo">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <p>{{sintomas.sintoma29.descripcion}}</p>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma29.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma29.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma29.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.sintoma29.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <div class="md-layout md-gutter fondo-verde">
          <div class="md-layout-item md-small-size-100 md-size-70 border">
            <h3 class="upper">{{sintomas.cumple_crit_cancer.descripcion}}</h3>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.cumple_crit_cancer.primeravez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.cumple_crit_cancer.primeravez"
              :value="false"
            >No</md-radio>
          </div>
          <div class="md-layout-item md-small-size-50 md-size-15 border">
            <md-radio
              class="radio-color"
              v-model="sintomas.cumple_crit_cancer.segundavez"
              :value="true"
            >Si</md-radio>
            <md-radio
              class="radio-color"
              v-model="sintomas.cumple_crit_cancer.segundavez"
              :value="false"
            >No</md-radio>
          </div>
        </div>

        <cuestionario-lactancia-parasitosis
          class="mt-5"
          v-model="cues_lactancia"
        />

      </md-card-content>

      <md-card-actions>
        <md-button>Cancelar</md-button>
        <md-button class="md-primary md-raised">Guardar</md-button>
      </md-card-actions>

    </md-card>

  </div>
</template>

<script>
import CuestionarioLactanciaParasitosis from "@/views/lactancia/CuestionarioLactanciaParasitosis";

export default {
  name: "CedulaSospechaCancer",
  components: { CuestionarioLactanciaParasitosis },
  data() {
    return {
      cues_lactancia: null,
      sintomas: {
        sintoma1: {
          descripcion:
            "Fiebre mayor a 38°C, por más de 7 días sin causa aparente",
          primeravez: false,
          segundavez: false
        },
        sintoma2: {
          descripcion:
            "Dolor de cabeza, persistente y progresivo: de predominio nocturno, que despierta al menor o aparece al momento de levantarse y puede acompañarse de vómito",
          primeravez: false,
          segundavez: false
        },
        sintoma3: {
          descripcion:
            "Dolores óseas unilaterales que han aumentado progresivamente en el último mes e interrumpen su actividad",
          primeravez: false,
          segundavez: false
        },
        sintoma4: {
          descripcion:
            "Petequias, moretones, gingivorragias y/o sangrados sin expliación",
          primeravez: false,
          segundavez: false
        },
        sintoma5: {
          descripcion: "Palidez palmar o conjuntival severa",
          primeravez: false,
          segundavez: false
        },
        sintoma6: {
          descripcion: "Leucocoria (ojo blanco)",
          primeravez: false,
          segundavez: false
        },
        sintoma7: {
          descripcion: "Estrabismo que ha ido apareciendo",
          primeravez: false,
          segundavez: false
        },
        sintoma8: {
          descripcion:
            "Alteración en la visión (borrosa, doble o ceguera súbita)",
          primeravez: false,
          segundavez: false
        },
        sintoma9: {
          descripcion: "Aniridia (falta de iris)",
          primeravez: false,
          segundavez: false
        },
        sintoma10: {
          descripcion: "Hifema (Sangre en ojo) y/o Proptosis (ojo saltado)",
          primeravez: false,
          segundavez: false
        },
        sintoma11: {
          descripcion:
            "Ganglios > 2.5cm de diámetro, duros, no dolorosas, evolución > a 4 Semanas",
          primeravez: false,
          segundavez: false
        },
        sintoma12: {
          descripcion:
            "Convulsión sin fiebre ni enfermedad neurológica de base",
          primeravez: false,
          segundavez: false
        },
        sintoma13: {
          descripcion:
            "Debilidad unilateral (una de las extremidades o un lado del cuerpo)",
          primeravez: false,
          segundavez: false
        },
        sintoma14: {
          descripcion: "Asimetría física (facial)",
          primeravez: false,
          segundavez: false
        },
        sintoma15: {
          descripcion:
            "Cambios del estado de conciencia o mental (comportamiento, confusión)",
          primeravez: false,
          segundavez: false
        },
        sintoma16: {
          descripcion: "Pérdida del equilibrio al caminar",
          primeravez: false,
          segundavez: false
        },
        sintoma17: {
          descripcion: "Cojea por dolor",
          primeravez: false,
          segundavez: false
        },
        sintoma18: {
          descripcion: "Dificultad para hablar",
          primeravez: false,
          segundavez: false
        },
        sintoma19: {
          descripcion: "Masa palpable en abdomen, riñon, higado, bazo u ovario",
          primeravez: false,
          segundavez: false
        },
        sintoma20: {
          descripcion: "Hepatomegalia y/o esplenomegalia",
          primeravez: false,
          segundavez: false
        },
        sintoma21: {
          descripcion: "Crecimiento asimétrico testicular",
          primeravez: false,
          segundavez: false
        },
        sintoma22: {
          descripcion:
            "Masa en alguna región del cuerpo, extremidades o tronco",
          primeravez: false,
          segundavez: false
        },
        sintoma23: {
          descripcion: "Pérdida de apetito en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma24: {
          descripcion: "Pérdida de peso en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma25: {
          descripcion: "Cansancio o fatiga en los últimos 3 meses",
          primeravez: false,
          segundavez: false
        },
        sintoma26: {
          descripcion: "Sudoración nocturna importante, sin causa aparente",
          primeravez: false,
          segundavez: false
        },
        sintoma27: {
          descripcion: "Palidez palmar o conjuntival leve",
          primeravez: false,
          segundavez: false
        },
        sintoma28: {
          descripcion:
            "Linfadenopatía dolorosa o con evlolución < 4 semanas o con diámetro < 2.5cm o consistencia no dura",
          primeravez: false,
          segundavez: false
        },
        sintoma29: {
          descripcion:
            "Aumenta de volumen en cualquier región del cuerpo con signos de inflamación",
          primeravez: false,
          segundavez: false
        },
        cumple_crit_cancer: {
          descripcion: "cumple criterios para sospechar cáncer",
          primeravez: false,
          segundavez: false
        }
      }
    };
  }
};
</script>